import { Pipe, type PipeTransform } from '@angular/core';
import type { ActiveUser } from '../models/api/user.model';

@Pipe({
  name: 'opaFindUser',
  standalone: true,
})
export class FindUserPipe implements PipeTransform {
  transform(id: string | null, users: ActiveUser[]): ActiveUser | undefined {
    if (!id) return undefined;

    return users.find((user) => `${user.id}` === id);
  }
}
